import { faBan, faStickyNote, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Node } from 'reducers/nodesReducer';

type TEnabledNodeRow = {
  node: Node;
  onEdit: () => void;
  authorized: boolean;
  onClick: () => void;
  onDisable: () => void;
};

export default function EnabledNodeRow({
  node,
  authorized,
  onClick,
  onEdit,
  onDisable,
}: TEnabledNodeRow): React.ReactElement {
  return (
    <tr className="node-row" onClick={onClick} style={{ cursor: 'pointer' }}>
      <td>
        <strong title={node.aeTitle}>{node.aeTitle}</strong>
      </td>
      <td>{node.protocol}</td>
      <td>
        {node.protocol === 'DICOM' ? (
          <div title={`${node.aeTitle}@${node.ip}:${node.port}`}>{`${node.aeTitle}@${node.ip}:${node.port}`}</div>
        ) : (
          <div title={node.stowRsEndpoint}>{node.stowRsEndpoint}</div>
        )}
      </td>
      <td>
        {node.notes && (
          <OverlayTrigger trigger="hover" placement="top" overlay={NotesOverlay(node.notes)}>
            <FontAwesomeIcon icon={faStickyNote} className="clickable-icon clickable-icon-notes" onClick={onEdit} />
          </OverlayTrigger>
        )}
      </td>
      <td>
        {authorized && node.aeTitle !== 'SYS_PR0XY' && (
          <FontAwesomeIcon icon={faBan} className="clickable-icon" onClick={onDisable} title="Disable node" />
        )}
        {authorized && <FontAwesomeIcon icon={faWrench} className="clickable-icon" onClick={onEdit} />}
      </td>
    </tr>
  );
}

const NotesOverlay = notes => (
  <Popover id="notesOverlay">
    <div style={{ whiteSpace: 'pre-wrap' }}>{notes}</div>
  </Popover>
);
